import { Suspense } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import useUIContext from '~/ui/use-ui-context.ts';
import MainModal from '~/components/main-modal/main-modal-container.js';
import NullLoader from '../../../null-loader.js';

const MainWrapper = styled(motion.div)`
	.game-grid-container,
	.shop-grid {
		padding-top: 12px;
	}
	filter: ${({ uiContext }) => (uiContext.hasMainBlurred ? 'blur(7px)' : '')};
	min-width: 0;
`;
// REV-251, after 7s, if delayed footer is enable and maincontent loaded flag is not set to LOADED,
// set it here and log warning, since footer is not displayed otherwise

const MainWrapperContainer = ({ children, ...props }) => {
	const uiContext = useUIContext();

	return (
		<MainWrapper uiContext={uiContext} {...props}>
			<Suspense fallback={NullLoader}>
				<MainModal />
				{children}
			</Suspense>
		</MainWrapper>
	);
};
export default MainWrapperContainer;
